// import * as React from "react";

import React, { Component } from "react";

const throttle = require("lodash.throttle");

class InfiniteScrollSimple extends Component {
  // private sentinel: HTMLDivElement;
  // private scrollHandler: () => void;
  // private resizeHandler: () => void;

  constructor(props) {
    super(props);

    // threshold: 100,
    // throttle: 64,
  }

  componentDidMount() {
    this.scrollHandler = throttle(this.checkWindowScroll, this.props.throttle);
    this.resizeHandler = throttle(this.checkWindowScroll, this.props.throttle);

    window.addEventListener("scroll", this.scrollHandler);
    window.addEventListener("resize", this.resizeHandler);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollHandler);
    window.removeEventListener("resize", this.resizeHandler);
  }

  componentDidUpdate() {
    // This fixes edge case where initial content is not enough to enable scrolling on a large screen.
    this.checkWindowScroll();
  }

  checkWindowScroll = () => {
    if (this.props.isLoading) {
      return;
    }

    if (
      this.props.hasMore &&
      this.sentinel.getBoundingClientRect().top - window.innerHeight <
        this.props.threshold
    ) {
      this.props.onLoadMore();
    }
  };

  render() {
    const sentinel = <div ref={i => (this.sentinel = i)} />;

    if (this.props.render) {
      return this.props.render({
        sentinel,
        children: this.props.children
      });
    }

    if (this.props.component) {
      const Container = this.props.component;
      return <Container sentinel={sentinel}>{this.props.children}</Container>;
    }

    return (
      <div>
        {this.props.children}
        {sentinel}
      </div>
    );
  }
}

export default InfiniteScrollSimple;
